// extracted by mini-css-extract-plugin
export default {"wrapper":"BookItem_wrapper__ApPOf","title":"BookItem_title__qIuWh"};